export const CHECKOUT_URL = "https://perimenopause-en.impultienda.ar/checkout/";

export const MOCKUP_URL =
  "https://cdn.magicpatterns.com/uploads/t5CRDr9p7gTatACK31APJB/MOCKUP_PERIMENOPAUSE-EN.png";

export const AUTHOR_PHOTO_URL =
  "https://cdn.magicpatterns.com/uploads/eEfGTn21KVjpWMcigWxmkP/Dra_Karito_real.png";

// Countdown restarts automatically every 00:17:34
export const COUNTDOWN_SECONDS = 17 * 60 + 34;

export const TOTAL_SPOTS = 100;
export const STARTING_SPOTS_LEFT = 9;
export const MIN_SPOTS_LEFT = 3;
